export default function ({ firstName = '', middleName = '', lastName = '' }) {
  return `${firstName} ${middleName} ${lastName}`;
}

export function formatAttendeeNameFromResource({ firstName = '', lastName = '' }, translate) {
  return translate('EventWidgets_InviteeName__resx', { firstName, lastName });
}
